//TODO: Lookup alternative method to setup the keys with out hard coding them to app
export const optimizelySdkKeys = {
  development: 'XyccijfZCYpBsTC64kC91',
  test: '3iVMfcvRihscXxTVBf49b',
  staging: '7mpLmgQBNZkBsKgqnS7nP',
  production: 'SLanGTzucTrKM1cXTvSUm',
}